import { render } from "./BaseLinkPickerInternalLink.vue?vue&type=template&id=6dd65f05&ts=true"
import script from "./BaseLinkPickerInternalLink.vue?vue&type=script&lang=ts"
export * from "./BaseLinkPickerInternalLink.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__